export interface Choice {
    key: string,
    value: string
}

export enum PumpChoiceKeys {
    FREQUENCY = 'frequency',
    PUMP_TYPE = 'pump_type',
    SEAL_TYPE = 'seal_type',
    SOLIDS_SIZE = 'solids_size',
    IMPELLER_TYPE = 'impeller_type',
    LOCATION = 'location',
    HORSEPOWER = 'horsepower',
    GRINDER_SERIES = 'grinder_series'
}
